import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    messages: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Open default email client with pre-filled content
    const subject = `Contact from ${formData.fullname}`;
    const body = `Message from: ${formData.fullname}\nEmail: ${formData.email}\n\n${formData.messages}`;
    window.location.href = `mailto:midnightghoulgames@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Reset form
    setFormData({
      fullname: '',
      email: '',
      messages: ''
    });
  };

  return (
    <section className="contact" id="contact">
      <div className="content">
        <div className="text">
          <h3>Get In Touch</h3>
          <p>Have questions or want to collaborate? We'd love to hear from you! Reach out through our contact form or join our community on Discord.</p>
        </div>
        <div className="contactForm">
          <form onSubmit={handleSubmit}>
            <div className="row100">
              <div className="inputBox50">
                <input 
                  type="text" 
                  name="fullname" 
                  placeholder="Full Name"
                  value={formData.fullname}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="inputBox50">
                <input 
                  type="email" 
                  name="email" 
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="row100">
              <div className="inputBox100">
                <textarea 
                  name="messages" 
                  placeholder="Message"
                  value={formData.messages}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
            </div>
            <div className="row100">
              <div className="inputBox100">
                <input type="submit" value="Send" />
              </div>
            </div>
          </form>
        </div>
        <div className="social">
          <li>
            <a href="https://discord.gg/qAkrJKmvnS" target="_blank" rel="noopener noreferrer" className="social-icon">
              <box-icon name='discord-alt' type='logo' color="#ffffff"></box-icon>
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/midnightghoulgames" target="_blank" rel="noopener noreferrer" className="social-icon">
              <box-icon name='facebook' type='logo' color="#ffffff"></box-icon>
            </a>
          </li>
        </div>
      </div>
    </section>
  );
}

export default Contact;
